<nav mat-tab-nav-bar class="col mat-center-links">
  <a mat-tab-link
     *ngIf="isSitesSectionAllowed"
     [routerLink]="'sites'"
     routerLinkActive #rla3="routerLinkActive"
     [active]="rla3.isActive">
    Sites
  </a>
  <a mat-tab-link
     [routerLink]="'units'"
     routerLinkActive #rla2="routerLinkActive"
     [active]="rla2.isActive">
    Units
  </a>
</nav>

<router-outlet></router-outlet>
